import { createSlice } from "@reduxjs/toolkit";

export interface authStateType {
    loading: boolean;
    getCodeLoading: boolean;
    setPasswordLoading: boolean;
    setSignoutLoading: boolean;
    setSessionSignoutLoading: boolean;
    successMessage: {};
    loginDevice: [];
    error: Error | null;
}
const initialState: authStateType = {
    loading: false,
    getCodeLoading: false,
    setPasswordLoading: false,
    setSignoutLoading: false,
    setSessionSignoutLoading: false,
    loginDevice: [],
    successMessage: {},
    error: null,
};

export const authStateSlice = createSlice({
    name: "authStateSlice",
    initialState,
    reducers: {
        // GET Seurity Code
        getSecurityCode: (state, action) => {
            state.loading = true;
        },
        getSecurityCodeSuccess: (state, action) => {
            state.loading = false;
        },
        getSecurityCodeError: (state, action) => {
            state.loading = false;
        },

        // Validate Security Code
        validateSecurityCode: (state) => {
            state.loading = true;
        },
        validateSecurityCodeSuccess: (state, action) => {
            state.loading = false;
        },
        validateSecurityCodeError: (state, action) => {
            state.loading = false;
        },

        // GET loged in device info
        getLoginDeviceInfo: (state) => {
            state.loading = true;
        },
        getLoginDeviceInfoSuccess: (state, action) => {
            state.loginDevice = action.payload;
            state.loading = false;
        },
        getLoginDeviceInfoError: (state, action) => {
            state.loading = false;
        },
        // GET Seurity Code for set password
        getCodeForPassword: (state, action) => {
            state.getCodeLoading = true;
        },
        getCodeForPasswordSuccess: (state, action) => {
            state.getCodeLoading = false;
        },
        getCodeForPasswordError: (state, action) => {
            state.getCodeLoading = false;
        },
        // GET Seurity Code for set password
        updatePasswordWithCode: (state, action) => {
            state.setPasswordLoading = true;
        },
        updatePasswordWithCodeSuccess: (state, action) => {
            state.setPasswordLoading = false;
        },
        updatePasswordWithCodeError: (state, action) => {
            state.setPasswordLoading = false;
        },
        // Signout from everywhere
        signoutFromEverywhere: (state, action) => {
            state.setSignoutLoading = true;
        },
        signoutFromEverywhereSuccess: (state, action) => {
            state.setSignoutLoading = false;
        },
        signoutFromEverywhereError: (state, action) => {
            state.setSignoutLoading = false;
        },
        // Signout from specific session
        sessionSignout: (state, action) => {
            state.setSignoutLoading = true;
        },
        sessionSignoutSuccess: (state, action) => {
            state.setSignoutLoading = false;
        },
        sessionSignoutError: (state, action) => {
            state.setSignoutLoading = false;
        },
    }
});

export const {
    getSecurityCode, getSecurityCodeSuccess, getSecurityCodeError,
    validateSecurityCode, validateSecurityCodeError, validateSecurityCodeSuccess, getLoginDeviceInfo,
    getLoginDeviceInfoSuccess, getLoginDeviceInfoError, getCodeForPassword, getCodeForPasswordSuccess,
    getCodeForPasswordError, updatePasswordWithCode, updatePasswordWithCodeSuccess, updatePasswordWithCodeError,
    signoutFromEverywhere, signoutFromEverywhereSuccess, signoutFromEverywhereError, sessionSignout, 
    sessionSignoutSuccess, sessionSignoutError

} = authStateSlice.actions;

export default authStateSlice.reducer;